import { Repository } from "./Repository";

export const ReleasesRepository = new Repository({ path: "releases" });
